import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class ViewTrainersGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
      super(
        'Trainer List',
        ROUTE_PATH.viewTrainers,
        ROUTE_PATH.trainersGrid,
        false,
        false,
        8,
        false,
        false,
        ['topic', 'batch', 'category_id', 'mobile_number'],
        false,
        [],
        { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
        false,
        null,
        true,
        true,
        false,
        "",
        { evalKey: 'wantToDelete', evalParam: [1], decisiveParam: true },
        false,
        "",
        null,
        null,
        true,
        true,
        true,
        [],
        true,
        {
          isExtraActions: false,
          btnLabel: '',
          selectOptions: [],
          selectedValue: '',
        },
        {isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: ''},
        {isDownload: false, key: '', valueKey: ''},
        null,
        false,
        false,
        {
          isPrimary: false,
          isDanger: false,
        },
        '',
        null,
        true,
      );
    }
  
    prepareHeaderList(): Headers[] {
      const headers: Headers[] = [];
      const topic = new Headers(
        'Assignment Topic',
        'topic',
        false,
        false,
        'text',
        '0',
        
      );
      const type = new Headers('Type', 'type_name', false, false, 'text');
      const batch = new Headers(
        'Batch',
        'batch_number',
        false,
        false,
        'text'
      );
      const timeslot = new Headers(
        'Date and Time',
        'timeslot_info',
        false,
        false,
        'text'
      );
  
      const invited = new Headers(
        'Invited',
        'invited',
        false,
        false,
        'text',
        '0',
        { isColumnNavigation: true, navigationUrl: ROUTE_PATH.invited, navigateOperationType: OperationType.VIEW, navigateTransferData: new GridParams() ,navigatePageName:'Invited'}
      );
  
      const accepted_student = new Headers(
        'Accepted',
        'accepted',
        false,
        false,
        'text',
        "0",
        { isColumnNavigation: true, navigationUrl: ROUTE_PATH.assignment_accepted, navigateOperationType: OperationType.VIEW, navigateTransferData: new GridParams(),navigatePageName:'Assignment Accepted' });
       
      
  
      // const accepted_student = new Headers('Accepted', 'accepted', false, false, 'text', '0', { isColumnNavigation: true, navigationUrl: ROUTE_PATH.assignment_accepted, navigateOperationType: OperationType.VIEW, navigateTransferData: new GridParams() })
  
      const nonaccepted = new Headers(
        'Non Accepted',
        'non_accepted',
        false,
        false,
        'text',
        '0',
        { isColumnNavigation: true, navigationUrl: ROUTE_PATH.assignment_not_accepted, navigateOperationType: OperationType.VIEW, navigateTransferData: new GridParams(),navigatePageName:'Non Accepted' }
      );
  
      const overallFeedback = new Headers(
        'Provide overall Feedback',
        'overallfeedback',
        false,
        false,
        'text',
       
      );
      
      headers.push(topic);
      headers.push(type);
      headers.push(batch);
      headers.push(timeslot);
      headers.push(invited);
      headers.push(accepted_student);
      headers.push(nonaccepted);
      headers.push(overallFeedback);
      return headers;
    }
  
    getNavigationGridParam(){
      const param = new GridParams();
      param.pathParam = 'Trainers';
      return param;
    }
  }